
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.157 9.123C6.834 7.733 9.254 6.25 12 6.25c2.746 0 5.166 1.483 6.843 2.873a19.335 19.335 0 012.556 2.572c.064.078.113.14.147.184.017.022.03.04.04.051l.01.015.003.004.001.002-.6.449c.601.448.6.449.6.449v.002l-.004.004-.01.015-.04.05a16.926 16.926 0 01-.695.825 19.332 19.332 0 01-2.008 1.932c-1.677 1.39-4.097 2.873-6.843 2.873-2.746 0-5.166-1.483-6.843-2.873a19.331 19.331 0 01-2.556-2.572c-.064-.078-.113-.14-.147-.184-.017-.022-.03-.04-.04-.051l-.01-.015-.003-.004-.001-.002.6-.449-.6-.449v-.002l.004-.004.01-.015.04-.05a16.903 16.903 0 01.695-.825 19.334 19.334 0 012.008-1.932zM3 12.4l-.6-.449a.75.75 0 00-.001.897L3 12.4zm.965 0a17.833 17.833 0 002.15 2.123c1.58 1.31 3.66 2.527 5.885 2.527 2.224 0 4.305-1.218 5.885-2.527a17.822 17.822 0 002.15-2.123 17.822 17.822 0 00-2.15-2.123C16.305 8.967 14.225 7.75 12 7.75c-2.224 0-4.305 1.217-5.885 2.527a17.833 17.833 0 00-2.15 2.123zM21 12.4l.6.449a.75.75 0 00.001-.898L21 12.4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 12.4a3 3 0 116 0 3 3 0 01-6 0z"}})])
          )
        }
      }
    